import { PosSystemType } from '@ready/dashboardv2api.contracts';

export const isReadySmb = (posSystemType?: PosSystemType) => posSystemType === PosSystemType.basicpos;
